import { useTheme } from 'styled-components';

import { ThemeMode } from '@sternum/web/components/theme/main/ThemeMode.context';
import { ct } from '@sternum/web/utils/theme';

export function useThemedValue<T>(stylesPerThemeMode: Record<ThemeMode, T>): T {
  const theme = useTheme();

  return ct(stylesPerThemeMode)({ theme });
}
